import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import api from "./api/_index";
import axios from "axios";

//设置axios为form-data
axios.defaults.transformRequest = [
  function (data) {
    let ret = "";
    for (let i in data) {
      ret += encodeURIComponent(i) + "=" + encodeURIComponent(data[i]) + "&";
    }
    return ret;
  },
];

//然后再修改原型链
Vue.prototype.$axios = axios;
Vue.prototype.$api = api;

// rem的适配插件
import "amfe-flexible";

import vant from "vant";
import "vant/lib/index.css";
Vue.use(vant);

Vue.config.productionTip = false;
Vue.prototype.checkIsLogin = function () {

  if (localStorage.getItem("uid") == null) {
    window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hbrb.jiyun';
  }

}
Vue.prototype.isLogin = function () {

  return (localStorage.getItem("uid") != null)
}
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
